import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HardHatIcon } from 'lucide-react';
export function ConstructionHauling() {
  return <div className="w-full min-h-screen bg-white" data-id="element-279">
      <Header data-id="element-280" />
      {/* Hero Section */}
      <section className="relative h-[400px] w-full" data-id="element-281">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2K6f4cRnzuB3bSEcm4rM8H/Construction-Clean-Out-Hauling.png" alt="Construction & Clean-Out Hauling" className="w-full h-full object-cover" data-id="element-282" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" data-id="element-283"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-284">
          <div className="text-center" data-id="element-285">
            <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center mx-auto mb-4" data-id="element-286">
              <HardHatIcon className="w-10 h-10 text-[#E41C1C]" data-id="element-287" />
            </div>
            <h1 className="text-5xl font-bold text-white" data-id="element-288">
              Construction & Clean-Out Hauling
            </h1>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-289">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-290">
          <div className="space-y-6" data-id="element-291">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-292">
              Construction projects and major clean-outs generate substantial
              amounts of debris that require professional handling. Our
              construction and clean-out hauling service provides durable
              dumpsters designed to handle heavy materials like drywall, lumber,
              roofing materials, concrete, and more. Whether you're a contractor
              working on a new build, a homeowner tackling a renovation, or
              managing an estate clean-out, we have the equipment and expertise
              to keep your project moving forward.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-293">
              We know that timing is critical on job sites. That's why we
              coordinate delivery and pickup around your schedule, ensuring you
              have the container when you need it and that it's removed promptly
              when you're done. Our team understands construction timelines and
              works efficiently to support your project without causing delays
              or disruptions.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-294">
              Safety and compliance are priorities for us. We ensure that all
              debris is disposed of properly and in accordance with local
              regulations. From small remodeling projects to large-scale
              construction jobs, Sam's Disposal has the capacity and reliability
              to handle your hauling needs, allowing you to focus on getting the
              work done right.
            </p>
          </div>
          {/* CTA Section */}
          <div className="mt-12 p-8 bg-gray-50 rounded-lg text-center" data-id="element-295">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-296">
              Schedule Your Construction Dumpster
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-297">
              Get the right size dumpster delivered to your job site when you
              need it.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-298">
              <a href="tel:231-796-2952" className="bg-[#E41C1C] text-white font-bold px-8 py-4 rounded hover:bg-red-700 transition-colors text-lg" data-id="element-299">
                Call (231) 796-2952
              </a>
              <button className="bg-white border-2 border-[#E41C1C] text-[#E41C1C] font-bold px-8 py-4 rounded hover:bg-gray-50 transition-colors text-lg" data-id="element-300">
                Request Delivery
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-301" />
    </div>;
}